import { Stack, styled } from '@mui/material'
import { NewGridContainer } from 'components/common/common.style'
import { themeUtils } from 'styles/theme'

export const SearchContentContainer = styled(NewGridContainer)`
  ${themeUtils.maxWidth.md} {
    margin: 16px 0;
  }
`

export const MapDisplayButtonContainer = styled(Stack)`
  position: fixed;
  bottom: 24px;
  z-index: 102;
  left: 50%;
  transform: translateX(-50%);
`
